import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetGenders = () => {
    const {
        isFetching: isLoading, data: genders, error,
    } = useQuery({
        queryKey: ["GenderTypes"],
        queryFn: () => axiosManager.get$("/parent/api/GenderTypes").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const gendersOptions = (genders || []).map((item) => ({ value: item.genderTypeId, label: item.name }));

    return {
        isLoading, genders, error, gendersOptions,
    };
};
